import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=a35a8912&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=a35a8912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35a8912",
  null
  
)

export default component.exports